
import setting from './setting';
export default {
    getList: ($axios,data)=>{
        return $axios.get(`${setting.http.base_url}/usuario/lista`,{headers:setting.http.headers()});
    },
    getToken: ($axios,data)=>{
        return $axios.post(`https://laive-adm-p45wb2lx3a-ue.a.run.app/api/usuarios/login`,data, {});
    },
}